import { useEffect, useRef } from "react";

/**
 * Lightweight SEO helper — sets document.title and the most useful meta tags.
 * No external dep required; works fine for our single-page React app.
 */
export default function Seo({ title, description, image, url }) {
  const prevTitle = useRef(typeof document !== "undefined" ? document.title : "");

  useEffect(() => {
    if (title) document.title = title;

    const tags = [
      { name: "description", content: description },
      { property: "og:title", content: title },
      { property: "og:description", content: description },
      { property: "og:type", content: "website" },
      { property: "og:image", content: image },
      { property: "og:url", content: url },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: title },
      { name: "twitter:description", content: description },
      { name: "twitter:image", content: image },
    ];

    const created = [];
    tags.forEach(({ name, property, content }) => {
      if (!content) return;
      const selector = name
        ? `meta[name="${name}"]`
        : `meta[property="${property}"]`;
      let el = document.head.querySelector(selector);
      if (!el) {
        el = document.createElement("meta");
        if (name) el.setAttribute("name", name);
        if (property) el.setAttribute("property", property);
        document.head.appendChild(el);
        created.push(el);
      }
      el.setAttribute("content", content);
    });

    const savedTitle = prevTitle.current;
    return () => {
      created.forEach((el) => el.parentNode && el.parentNode.removeChild(el));
      if (savedTitle) document.title = savedTitle;
    };
  }, [title, description, image, url]);

  return null;
}
